import { createContext } from 'react';
import { DarkModeContextData } from './interfaces/darkmode-context-props.interface';

const DarkModeContext = createContext<DarkModeContextData>(
    {} as DarkModeContextData,
);

export default DarkModeContext;
